// extracted by mini-css-extract-plugin
export default {"wrapper":"DemoBanner_wrapper__aj41E"};